<template>
  <div class="navbar rx-bc">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" :click-fn="toggleSideBar" />

    <!-- <breadcrumb id="breadcrumb-container" class="breadcrumb-container" /> -->

    <div class="collapse rx-cc" @click="closeSideBar">
      <svg-icon icon-class="collapse" />
    </div>

    <div class="item rx-cc">
      <el-select v-model="value" filterable placeholder="菜单检索" style="width: 160px" @change="handleChange">
        <el-option v-for="(item, index) in options" :key="index" :label="item.name" :value="item.value" />
      </el-select>
    </div>

    <div class="right-menu flex1 rx-ec">
      <template v-if="device !== 'mobile'">
        <!-- <search id="header-search" class="right-menu-item" /> -->

        <!-- <error-log class="errLog-container right-menu-item hover-effect" /> -->

        <!-- <screenfull id="screenfull" class="right-menu-item hover-effect" /> -->

        <!-- <el-tooltip content="Global Size" effect="dark" placement="bottom">
          <size-select id="size-select" class="right-menu-item hover-effect" />
        </el-tooltip> -->
      </template>
      <div v-if="aiUserInfoForm.aihelp && Number(aiUserInfoForm.aihelp) === 1" class="AiLogo" @click="openAi">
        <div class="AiLogo-item">
          <img src="@/assets/img/aiLogo.gif" alt="" class="aiLogo" />
          <span class="text">AI智能助手</span>
        </div>
      </div>

      <div class="ft14 right-menu-item mr10 cursor-p ellipsiss" style="max-width: 50%" @click="switchAccount()">
        <span class="ft14 mr10">{{ taxName }}</span>
        <img src="@/assets/img/check.png" class="checkImg" />
      </div>
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click"
        style="max-width: 50%"
        @command="handleCommand"
      >
        <div class="avatar-wrapper rx-ss" style="word-break: break-all">
          <div class="ft14 ellipsis">{{ tels }}</div>
          <div class="ft14 ellipsis">（{{ names }})</div>
          <i class="el-icon-caret-bottom" style="line-height: 0px" />
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="logout">
              <span style="display: block">退出登录</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </div>
    <el-dialog :visible="switchVisible" title="选择服务商" width="600px" :before-close="handleClose" :modal="false">
      <div
        v-for="(item, index) of subAccountLi"
        :key="index"
        class="rx-sc pl15 pr15 pt10 pb10 cursor-p"
        :class="index != subAccountLi.length - 1 ? 'subAccount-item' : 'mb20'"
        @click="handleLogin(item)"
      >
        <div class="w50 h50 select-merchant-icon ta-c">
          <img
            :src="shellConst.iconPhoto || shellConst.websiteLogo || shellConst.systemPhoto"
            alt=""
            style="width: 50px; height: 50px; border-radius: 50%; object-fit: contain"
          />
        </div>
        <div class="ml10 flex1">
          <div class="">{{ item.taxName }}<span v-if="item.isLastLogin === 1" class="red">（当前登录）</span></div>
        </div>
      </div>
    </el-dialog>
    <ai-iframe v-show="iframeShow" ref="AIIFrameParent" :src="iframeSrc" class="AIIFrame" :ai-user-info-form="aiUserInfoForm" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from "@/components/Hamburger";
import AiIframe from "@/components/AiIframe";
import { aiUserInfo } from "@/api/user";
// import ErrorLog from '@/components/ErrorLog'
// import Screenfull from '@/components/Screenfull'
// import SizeSelect from '@/components/SizeSelect'
// import Search from '@/components/HeaderSearch'
// import { removeToken } from '@/utils/auth'
import { getSwitchAccount } from "@/api/user";
console.log(process.env.VUE_APP_IFRAME_SRC, "process");
export default {
  components: {
    Hamburger,
    AiIframe
  },
  data() {
    return {
      iframeSrc: process.env.VUE_APP_IFRAME_SRC,
      iframeShow: false,
      fId: localStorage.getItem("fId"),
      names: localStorage.getItem("names"),
      taxName: localStorage.getItem("taxName"),
      tels: localStorage.getItem("tels"),
      switchVisible: false,
      subAccountLi: [],
      options: [],
      value: "",
      aiUserInfoForm: {}
    };
  },
  computed: {
    ...mapGetters(["sidebar", "avatar", "device"]),
    shellConst() {
      return this.$store.state.domain.shellConst;
    }
  },
  watch: {
    $route: {
      handler(val, oldval) {
        if (val.name !== oldval.name) {
          // 路由变化
          this.handleClose();
        }
      },
      // 深度观察监听
      deep: true
    }
  },
  mounted() {
    this.userPhone = localStorage.getItem("fName");
    this.initRouter();
    this._aiUserInfo();
    window.addEventListener("message", event => {
      if (event.data.type === "closeIframeDialog") {
        this.iframeShow = false;
      }
    });
  },
  methods: {
    handleCommand(v) {
      if (v === "logout") {
        this.logout();
      }
    },
    async _aiUserInfo() {
      const res = await aiUserInfo();
      if (res.code === 200) {
        this.aiUserInfoForm = res.data;
      }
    },
    initRouter() {
      this.options = [];
      const role = this.$store.state.user.roles;
      role.map(item => {
        if (item.children && item.children.length > 0) {
          item.children.map(child => {
            if (child.meta.allow && child.path.split("/").length === 1) {
              const i = {
                name: child.meta.title,
                value: (item.path === "/" ? "" : item.path) + "/" + child.path
              };
              this.options.push(i);
            }
          });
        }
      });
    },
    handleChange(e) {
      this.$router.push(e);
      this.value = "";
    },
    closeSideBar() {
      this.$emit("close");
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      this.$confirm("是否确定退出登录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
          .dispatch("user/logout")
          .then(() => {
            this.$router.push(`/login?redirect=${this.$route.fullPath}`);
            localStorage.removeItem("selectStatus");
          })
          .catch(() => {
            this.loading = false;
          });
      });
    },
    handleClose() {
      this.switchVisible = false;
    },
    switchAccount() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(225, 225, 225, 0.7)"
      });
      getSwitchAccount({})
        .then(res => {
          this.subAccountLi = res.data;
          this.switchVisible = true;
          loading.close();
        })
        .catch(error => {
          loading.close();
          console.log(error);
        });
    },
    handleLogin(data) {
      this.loading = false;
      this.$store
        .dispatch("user/login", { id: this.fId, taxId: data.taxId })
        .then(() => {
          localStorage.setItem("taxName", data.taxName);
          this.$message({
            message: "切换成功",
            type: "success"
          });
          setTimeout(() => {
            location.reload();
          }, 200);
        })
        .catch(() => {
          this.switchVisible = false;
        });
    },
    openAi() {
      this.iframeShow = !this.iframeShow;
      this.$nextTick(() => {
        console.log("nextTick");
        // const iframe = this.$refs.AIIFrameParent.$refs.AIIFrame
        if (this.$refs.AIIFrameParent) {
          this.$refs.AIIFrameParent.onIframeLoad();
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.item {
  float: left;
  padding: 0 15px;
  height: 100%;
}
.collapse {
  float: left;
  padding: 0 15px;
  height: 100%;
  color: #000;
  font-size: 17px;
  cursor: pointer;
  &:hover {
    background: rgba(0, 0, 0, 0.025);
  }
}
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 50px;
    height: 100%;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    height: 100%;
    line-height: 50px;
    display: flex;
    align-items: center;
    .AiLogo {
      margin-right: 30px;
      box-sizing: border-box;
      height: 35px;
      overflow: hidden;
      width: 140px;
      box-sizing: border-box;
      border: 0.5px solid rgb(235 225 225);
      border-radius: 8px;
      .AiLogo-item {
        height: 35px;
        display: flex;
        align-items: center;
        padding-left: 5px;
        box-sizing: border-box;
        cursor: pointer;
        .aiLogo {
          height: 30px;
          margin-top: -2px;
          margin-right: 7px;
        }
        .text {
          height: 23px;
          line-height: 23px;
          color: rgba(0, 104, 255, 1);
          font-size: 16px;
          font-family: YSBiaoTiHei-regular;
          font-style: italic;
          font-weight: 600;
        }
      }
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
  .subAccount-item {
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
  .select-merchant-icon {
    color: #fff;
    border-radius: 50%;
    font-size: 10px;
    font-weight: 500;
  }
  .checkImg {
    width: 14px;
    vertical-align: middle;
    margin-top: -2px;
  }
}
</style>
